// Data pro Festival Koupáček 2026

export const festivalInfo = {
  name: "FESTIVAL KOUPÁČEK 2026",
  subtitle: "RODINNÝ FESTIVAL NA KOUPALIŠTI",
  date: "5. července 2026",
  time: "10:00–19:00",
  location: "Městské koupaliště Otrokovice",
  expectedVisitors: "2 000",
  entrance: "VSTUPNÉ: 399 Kč / RODINNÉ: 1 197 Kč",
  eventId: "festival-koupacek-2026",
};

export const programSchedule = {
  sunday: {
    day: "Neděle 5. 7. 2026",
    time: "10:00–19:00",
    description: "Celodenní program pro celou rodinu",
  },
};

export const programHighlights = [
  "🎤 Kája a Bambuláček",
  "🎤 Michal Nesvadba",
  "🎤 TARY – show, workshop a autogramiáda",
  "🫧 Matěj Kodeš – bublinářská show",
  "✨ Jirka Hadaš – moderátor a kouzelník",
  "🎭 Baba Jaga a Teta Květa",
  "🎤 Ela a Tom",
];

export const doprovodnyProgram = [
  "🎈 Dětské atrakce",
  "🤸 Parkourová zóna",
  "🎨 Kreativní dílničky",
  "📸 Fotokoutek",
  "⚡ Interaktivní aktivity pro děti",
  "💦 Koupaliště v provozu po celý den",
];

export const whyJoinReasons = [
  {
    title: "Ideální pro rodiny",
    description: "Festival Koupáček je zaměřený na rodiny s dětmi ve věku 2–14 let. Rodinné publikum má přirozeně vyšší spotřebu občerstvení během celého dne.",
    icon: "Users",
  },
  {
    title: "Celodenní návštěvnost",
    description: "Návštěvníci tráví v areálu více hodin a kombinují program festivalu s pobytem u vody. Stabilní prodej během celého dne.",
    icon: "Clock",
  },
  {
    title: "Atraktivní lokace",
    description: "Areál městského koupaliště v Otrokovicích v letní sezóně přirozeně přitahuje návštěvníky z širokého okolí.",
    icon: "MapPin",
  },
  {
    title: "Bohatý program",
    description: "Celodenní program na pódiu i v celém areálu. Pódiové vystoupení + doprovodné aktivity zajišťují dlouhou dobu návštěvy.",
    icon: "Star",
  },
  {
    title: "Vysoký prodejní potenciál",
    description: "Očekávaná návštěvnost 2000 návštěvníků během dne. Dlouhé hodiny pobytu v areálu = vyšší spotřeba občerstvení.",
    icon: "TrendingUp",
  },
  {
    title: "Omezený počet prodejců",
    description: "Počet prodejních míst je omezen, aby měl každý prodejce dostatečný prodejní potenciál bez přeplnění.",
    icon: "CheckCircle2",
  },
];

export const vendorCategories = {
  priority: {
    title: "PRIORITA: Food Trucky a Gastro Stánky",
    description: "Hledáme prodejce s rychlým a kvalitním občerstvením vhodným pro rodiny s dětmi.",
    requirements: [
      "Rychlé a kvalitní občerstvení",
      "Jídla vhodná pro rodiny s dětmi",
      "Zkušenosti z festivalů",
      "Schopnost rychlé obsluhy většího počtu návštěvníků",
    ],
  },
  additional: {
    title: "Doplňkový prodej",
    description: "Omezený počet míst pro doplňkový sortiment",
    categories: [
      "Sladké speciality a dezerty",
      "Zmrzlina a ledové pochoutky",
      "Hračky a dětské atrakce",
      "Handmade výrobky pro děti",
    ],
  },
};

export const importantRules = [
  {
    title: "Zákaz prodeje nápojů",
    description: "Alkoholické i nealkoholické nápoje zajišťuje výhradně pořadatel.",
    note: "Výjimky pouze po předchozí domluvě s pořadatelem.",
    icon: "XCircle",
  },
  {
    title: "Ceny bez DPH",
    description: "Všechny uvedené ceny jsou bez DPH. DPH bude připočítáno podle platné legislativy.",
    icon: "CreditCard",
  },
];

export const pricingConditions = {
  foodTrucks: {
    title: "FOOD TRUCKY/GASTRO STÁNKY",
    size: "max 6x3m",
    category: "hlavní prodejci jídla",
    price: "9.000 Kč",
  },
  additional: {
    title: "DOPLŇKOVÝ SORTIMENT",
    size: "max 6x3m",
    category: "ostatní prodejci",
    price: "4.500 Kč",
  },
  electricity: {
    title: "ENERGIE - příkon (MAX 12 KW)",
    options: [
      { range: "DO 3KW", price: "1.750 Kč" },
      { range: "3KW až 6KW", price: "3.300 Kč" },
      { range: "nad 6KW", price: "4.500 Kč" },
    ],
    note: "(celá akce)",
  },
  deposit: {
    title: "VRATNÁ KAUCE",
    price: "5.000 Kč",
  },
  note: "Ceny jsou uvedeny bez DPH",
};

export const contactInfo = {
  name: "Jakub Vodárek",
  phone: "+420 774 750 456",
  email: "info@vseproakci.cz",
};

export const heroImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/26hl5tl7_1920x1080%282%29.jpg";

export const logoImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/mgflms00_logo%20koupacek.png";
